import { LitElement, html, css } from "lit-element";
import {localize} from "@stofloos/actions/localize";

// language=CSS
export const InputDefaultStyle = css`
	.input-default {
		display: inline-block;
		text-align: left;
	}

	.input-default > input::-webkit-input-placeholder {
		color: transparent;
	}

	.input-default > input::-moz-placeholder {
		color: transparent;
	}

	.input-default > input:-ms-input-placeholder {
		color: transparent;
	}

	.input-default > input::-ms-input-placeholder {
		color: transparent;
	}

	.input-default > input {
		font-size: 1em;
		font-weight: 300;
		color: var(--app-primary);
		border: none;
		padding: 40px 0 8px;
		width: 100%;
		outline: none;
		background-color: transparent;
	}

	.input-default > input:invalid {
	}

	.input-default > input-md-decorator {
		display: block;
		height: 1px;
		width: 100%;
		margin: auto;
		border-top: 1px solid #ccc;
		position: relative;
		transform: translateZ(0);
		color: var(--app-primary);
	}

	.input-default input-underline {
		display: block;
		height: 2px;
		width: 100%;
		margin: auto;
		background-color: var(--app-accent, black);
		position: absolute;
		top: -1px;
		left: 0;
		transform: scale3d(0, 1, 1);
		transition: transform 0.2s ease-in;
	}

	.input-default > input-md-decorator > label {
		font-size: 18px;
		display: block;
		pointer-events: none;
		opacity: 0.5;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		transform-origin: 0 0;
		transition-property: opacity, font-size, transform;
		transition-duration: 0.15s;
		transition-timing-function: ease-out;
		will-change: transform;
		transform: translate3d(0px, -1.9em, 0px);
	}

	.input-default > input-md-decorator::after {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		font-size: 0.65em;
		color: #dd2c00;
		content: attr(error-message);
		display: none;
		white-space: nowrap;
	}

	.input-default > input:focus + input-md-decorator > input-underline {
		transform: scale3d(1, 1, 1);
		transition: transform 0.2s ease-out;
	}

	.input-default > input:focus + input-md-decorator > label {
		transform: translate3d(0px, -4.7em, 0px);
		font-size: 13px;
		opacity: 1;
	}

	.input-default > input:optional:not(:placeholder-shown) + input-md-decorator > label {
		transform: translate3d(0px, -4.7em, 0px);
		font-size: 13px;
		opacity: 1;
	}

	_:-ms-lang(x) > input + input-md-decorator > label {
		transform: translate3d(0px, -4.7em, 0px);
		font-size: 13px;
		opacity: 1;
	}

	.input-default > input:optional:-moz-ui-valid + input-md-decorator > label {
		transform: translate3d(0px, -3.4em, 0px) scale(0.7, 0.7);
		opacity: 1;
	}

	.input-default > input:not(:focus):not(:placeholder-shown):invalid + input-md-decorator > input-underline {
		background-color: #dd2c00;
		transform: scale3d(1, 1, 1);
		transition: transform 0.2s ease-out;
	}

	.input-default > input:not(:focus):-moz-ui-invalid:invalid + input-md-decorator > input-underline {
		background-color: #dd2c00;
		transform: scale3d(1, 1, 1);
		transition: transform 0.2s ease-out;
	}

	.input-default > input[aria-invalid="true"] + input-md-decorator > input-underline {
		background-color: #dd2c00;
		transform: scale3d(1, 1, 1);
		transition: transform 0.2s ease-out;
	}

	.input-default > input:not(:focus):not(:placeholder-shown):invalid + input-md-decorator::after {
		display: block;
	}

	.input-default > input:not(:focus):-moz-ui-invalid:invalid + input-md-decorator::after {
		display: block;
	}

	.input-default > input[aria-invalid="true"]:not(:valid) + input-md-decorator::after {
		display: block;
	}

	.input-default > input:not(:focus):not(:placeholder-shown):invalid + input-md-decorator > label {
		transform: translate3d(0px, -4.7em, 0px);
		font-size: 13px;
		opacity: 1;
		color: #dd2c00;
	}

	.input-default > input:not(:focus):-moz-ui-invalid:invalid + input-md-decorator > label {
		transform: translate3d(0px, -4.7em, 0px);
		font-size: 13px;
		opacity: 1;
		color: #dd2c00;
	}

	.input-default > input[aria-invalid="true"]:not(:valid) + input-md-decorator > label {
		transform: translate3d(0px, -4.7em, 0px);
		font-size: 13px;
		opacity: 1;
		color: #dd2c00;
	}

	.input-default > input:not(:focus):required:valid + input-md-decorator > label {
		transform: translate3d(0px, -4.7em, 0px);
		font-size: 13px;
		opacity: 1;
	}

	.input-default > input:required + input-md-decorator > label::after {
		content: " *";
	}
`;

// language=CSS
const InputDefaultHostStyle = css`
	:host {
		display: inline-block;
		text-align: left;
	}
	
	:host([hidden]) {
		display: none;
	}
	
	:host > input::-webkit-input-placeholder {
		color: transparent;
	}

	:host > input::-moz-placeholder {
		color: transparent;
	}

	:host > input:-ms-input-placeholder {
		color: transparent;
	}

	:host > input::-ms-input-placeholder {
		color: transparent;
	}

	:host > input {
		font-size: 1em;
		font-weight: 300;
		color: var(--app-primary);
		border: none;
		padding: 40px 0 8px;
		width: 100%;
		outline: none;
		background-color: transparent;
	}
	:host > input:invalid {
	}

	:host > input-md-decorator {
		display: block;
		height: 1px;
		width: 100%;
		margin: auto;
		border-top: 1px solid #ccc;
		position: relative;
		transform: translateZ(0);
		color: var(--app-primary);
	}

	:host input-underline {
		display: block;
		height: 2px;
		width: 100%;
		margin: auto;
		background-color: var(--app-accent, black);
		position: absolute;
		top: -1px;
		left: 0;
		transform: scale3d(0, 1, 1);
		transition: transform 0.2s ease-in;
	}

	:host > input-md-decorator > label {
		font-size: 18px;
		display: block;
		pointer-events: none;
		opacity: 0.5;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		transform-origin: 0 0;
		transition-property: opacity, font-size, transform;
		transition-duration: 0.15s;
		transition-timing-function: ease-out;
		will-change: transform;
		transform: translate3d(0px, -1.9em, 0px);
	}

	:host > input-md-decorator::after {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		font-size: 0.65em;
		color: #dd2c00;
		content: attr(error-message);
		display: none;
		white-space: nowrap;
	}

	:host > input:focus + input-md-decorator > input-underline {
		transform: scale3d(1, 1, 1);
		transition: transform 0.2s ease-out;
	}

	:host > input:focus + input-md-decorator > label {
		transform: translate3d(0px, -4.7em, 0px);
		font-size: 13px;
		opacity: 1;
	}

	:host > input:optional:not(:placeholder-shown) + input-md-decorator > label {
		transform: translate3d(0px, -4.7em, 0px);
		font-size: 13px;
		opacity: 1;
	}

	_:-ms-lang(x) > input + input-md-decorator > label {
		transform: translate3d(0px, -4.7em, 0px);
		font-size: 13px;
		opacity: 1;
	}

	:host > input:optional:-moz-ui-valid + input-md-decorator > label {
		transform: translate3d(0px, -3.4em, 0px) scale(0.7, 0.7);
		opacity: 1;
	}

	:host > input:not(:focus):not(:placeholder-shown):invalid + input-md-decorator > input-underline {
		background-color: #dd2c00;
		transform: scale3d(1, 1, 1);
		transition: transform 0.2s ease-out;
	}

	:host > input:not(:focus):-moz-ui-invalid:invalid + input-md-decorator > input-underline {
		background-color: #dd2c00;
		transform: scale3d(1, 1, 1);
		transition: transform 0.2s ease-out;
	}

	:host > input[aria-invalid="true"] + input-md-decorator > input-underline {
		background-color: #dd2c00;
		transform: scale3d(1, 1, 1);
		transition: transform 0.2s ease-out;
	}

	:host > input:not(:focus):not(:placeholder-shown):invalid + input-md-decorator::after {
		display: block;
	}

	:host > input:not(:focus):-moz-ui-invalid:invalid + input-md-decorator::after {
		display: block;
	}

	:host > input[aria-invalid="true"]:not(:valid) + input-md-decorator::after {
		display: block;
	}

	:host > input:not(:focus):not(:placeholder-shown):invalid + input-md-decorator > label {
		transform: translate3d(0px, -4.7em, 0px);
		font-size: 13px;
		opacity: 1;
		color: #dd2c00;
	}

	:host > input:not(:focus):-moz-ui-invalid:invalid + input-md-decorator > label {
		transform: translate3d(0px, -4.7em, 0px);
		font-size: 13px;
		opacity: 1;
		color: #dd2c00;
	}

	:host > input[aria-invalid="true"]:not(:valid) + input-md-decorator > label {
		transform: translate3d(0px, -4.7em, 0px);
		font-size: 13px;
		opacity: 1;
		color: #dd2c00;
	}

	:host > input:not(:focus):required:valid + input-md-decorator > label {
		transform: translate3d(0px, -4.7em, 0px);
		font-size: 13px;
		opacity: 1;
	}

	:host > input:required + input-md-decorator > label::after {
		content: " *";
	}
`;

export class StofwareInputDefault extends LitElement {
	static get properties() {
		return {
			name: { type: String },
			label: { type: String },
			type: { type: String },
			value: { type: String },
			pattern: { type: String },
			required: { type: Boolean },
			disabled: { type: Boolean },
			hidden: { type: Boolean }
		};
	}

	constructor() {
		super();
	}

	static get styles() {
		return InputDefaultHostStyle;
	}

	render() {
		return html`
			${!this.pattern || typeof this.pattern === "undefined"
				? html`
						<input
							type="${this.type}"
							name="${this.name}"
							value="${this.value ? this.value : ""}"
							placeholder="${this.label}"
							?hidden="${this.hidden}"
							?required="${this.required}"
							?disabled="${this.disabled}"
						/>
				  `
				: html`
						<input
							type="${this.type}"
							name="${this.name}"
							value="${this.value ? this.value : ""}"
							pattern="${this.pattern}"
							placeholder="${localize(this.label)}"
							?hidden="${this.hidden}"
							?required="${this.required}"
							?disabled="${this.disabled}"
						/>
				  `}

			<input-md-decorator aria-hidden="true">
                ${this.label ? html`
				    <label>${localize(this.label)}</label>
                ` : html`
				    <label>${localize([this.name, "properties::"+this.name])}</label>
                `}
				<input-underline></input-underline>
			</input-md-decorator>
		`;
	}
}

customElements.define("input-default", StofwareInputDefault);
